module.exports = __webpack_public_path__ + "static/media/main.5ed2f603.png";